import one from '../assets/svg/projects/one.png'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.png'
import six from '../assets/svg/projects/six.png'
import seven from '../assets/svg/projects/seven.png'
import eight from '../assets/svg/projects/eight.png'
import ninth from '../assets/svg/projects/ninth.png'
import tenth from '../assets/svg/projects/tenth.png'
import darosoft from '../assets/svg/projects/darosoft.png'
import alifa from '../assets/svg/projects/alifa.png'
import easydatastructures from '../assets/svg/projects/easydatastructures.png'
import bookory from '../assets/svg/projects/bookory.webp'
import acthire from '../assets/svg/projects/acthire.png'
import fastmotors from '../assets/svg/projects/fastmotors.webp'
import tma from '../assets/svg/projects/tma.png'
import kbapk from '../assets/svg/projects/kbapk.png'
import tempmail from '../assets/svg/projects/temp-mail.png'
import afeef from '../assets/svg/projects/afeef.png'
import bbminchem from '../assets/svg/projects/bbminchem.png'
import digitaltimez from '../assets/svg/projects/digital-timez.png'
import acm from '../assets/svg/projects/acm.png'
import qr from '../assets/svg/projects/qr-code.png'
import stargroup from '../assets/svg/projects/star-group.gif'
import idetep from '../assets/svg/projects/idetep.gif'



export const projectsData = [
    {
        id: 1,
        projectName: 'Easy Data Structures',
        projectDesc: 'Easy Data Structures, built with React JS, makes learning data structures simple and engaging through interactive animations and visualizations.',
        tags: ['React JS'],
        code: 'https://easydatastructures.com/',
        demo: 'https://easydatastructures.com/',
        image: easydatastructures   
    },
    {
        id: 2,
        projectName: 'KBAPK - High Quality Chemicals & Minerals',
        projectDesc: 'Reliable supply, consistent quality, and complete technical documentation, trusted by B2B buyers across diverse sectors.',    
        tags: ['WordPress'],
        code: 'https://kbapk.com/',
        demo: 'https://kbapk.com/',
        image: kbapk
    },
    {
        id: 3,
        projectName: 'Afeef Zara Packages',
        projectDesc: 'Afeef Zara Packages Pvt. LTD. is a leading packaging company in Karachi, Pakistan. We specialize in providing innovative and sustainable packaging solutions.',
        tags: ['WordPress'],
        code: 'https://afeefzarapackages.com/',
        demo: 'https://afeefzarapackages.com/',
        image: afeef
    },
    {
        id: 4,
        projectName: 'BB MinChem',
        projectDesc: 'BB MinChem is a global supplier of chemicals, minerals, and industrial raw materials.',    
        tags: ['WordPress'],
        code: 'https://bbminchem.com/',
        demo: 'https://bbminchem.com/',
        image: bbminchem
    },
    {
        id: 5,
        projectName: 'Towel Manufacturing Association (TMA)',
        projectDesc: 'Towel Association is an e-commerce site built on Shopify, offering products through a sleek, user-friendly online store.',    
        tags: ['Shopify'],
        code: 'https://lightyellow-jackal-363583.hostingersite.com/',
        demo: 'https://lightyellow-jackal-363583.hostingersite.com/',
        image: tma
    },
    {
        id: 6,
        projectName: 'Bookory Publishing',
        projectDesc: 'Bookory is a WordPress WooCommerce project for authors, publishers, and bookstores to easily sell books and eBooks online.',
        tags: ['WordPress'],
        code: 'https://trotsoft.com/',
        demo: 'https://trotsoft.com/',
        image: bookory
    },
    {
        id: 7,
        projectName: 'DaroSoft',
        projectDesc: 'DaroSoft, built on the WordPress CMS, is a dynamic software house offering professional website development services, delivering seamless and customizable digital solutions.',
        tags: ['WordPress'],
        code: 'https://darosoft.com/',
        demo: 'https://darosoft.com/',
        image: darosoft
    },
    {
        id: 8,
        projectName: 'Digital Timez (Password : password)',
        projectDesc: 'At Digital Timez, we are more than just a tech brand; we are purpose-driven movement to place Pakistan at the forefront of the global technology industry.',    
        tags: ['WordPress'],
        code: 'https://digital-timez.myshopify.com/',
        demo: 'https://digital-timez.myshopify.com/',
        image: digitaltimez
    },
    {
        id: 9,
        projectName: 'The Alifa',
        projectDesc: 'The Alifa, built on the WordPress CMS, is a dynamic digital agency delivering expert marketing solutions to boost visibility, engagement, and growth.',
        tags: ['WordPress'],
        code: 'https://thealifa.com/',
        demo: 'https://thealifa.com/',
        image: alifa
    },
    {
        id: 10,
        projectName: 'Act Hire',
        projectDesc: 'ACT Hire designed in WordPress, it delivers reliable dry hire solutions for the civil construction and earthmoving industries.',
        tags: ['WordPress'],
        code: 'https://acthire.com/',
        demo: 'https://acthire.com/',
        image: acthire
    },
    {
        id: 11,
        projectName: 'Fast Motors',
        projectDesc: 'Fast Motors, a Karachi-based dealership for ISUZU, FUSO, and FOTON vehicles, parts, and services — website built with WordPress CMS development.',
        tags: ['WordPress'],
        code: 'https://fast-motors.com/',
        demo: 'https://fast-motors.com/',
        image: fastmotors
    },
    {
        id: 12,
        projectName: 'Amy Cooke Movement',
        projectDesc: 'Amy Cooke Movement website provides expert Pilates and movement coaching focused on women’s health, injury recovery, and improving strength, posture, and overall wellbeing.',
        tags: ['Shopify'],
        code: 'https://www.amycookemovement.com/',
        demo: 'https://www.amycookemovement.com/',
        image: acm
    },
    {
        id: 13,
        projectName: '5 Star Real Estate (Password: "yourPassword")',
        projectDesc: '5 Stars Real Estate, 3rd, 4th Floor, Rasis Building, Al-Barsha, Dubai. UAE.',
        tags: ['HTML', 'CSS', 'JS', 'Bootstrap'],
        code: 'https://5-stars-real-estate.thevisionbrands.com/',
        demo: 'https://5-stars-real-estate.thevisionbrands.com/',
        image: stargroup
    },
    {
        id: 14,
        projectName: 'IDETEP',
        projectDesc: 'In partnership with the University of St. Francis R.E.A.L program, we are a graduate program that offers the required courses for public high school driver educators',
        tags: ['HTML', 'CSS', 'JS', 'Bootstrap'],
        code: 'https://idetep.org/',
        demo: 'https://idetep.org/',
        image: idetep
    },
    {
        id: 15,
        projectName: 'Yadgar Safar  Tourist Platform',
        projectDesc: 'Yadgar Safar is traveling platform whcih connects travellers and travels agencies together. where tourists can book tour of their choices by comparing different features of different travel agencies.',
        tags: ['React', 'NodeJS', 'ExpressJS', 'MongoDB'],
        code: 'https://www.youtube.com/watch?v=rj86XiQ9s70&ab_channel=VisualHow',
        demo: 'https://www.youtube.com/watch?v=rj86XiQ9s70&ab_channel=VisualHow',
        image: six
    },
    {
        id: 16,
        projectName: 'Online Bakery Collection',
        projectDesc: 'Online Bakery Collection is an online platform for booking and delivering bakery orders.',
        tags: ['React', 'Bootstrap', 'MySQL'],
        code: 'https://github.com/madanlal1/Online-Bakery-Collection/tree/main',
        demo: 'https://github.com/madanlal1/Online-Bakery-Collection/tree/main',
        image: seven
    },
    {
        id: 17,
        projectName: 'Hostel Management System',
        projectDesc: 'Hostel Management System Database Project is based on JAVA Programming which help to store hostel data.',
        tags: ['Java'],
        code: 'https://github.com/madanlal1/Hostel-Management-System-Database-Project',
        demo: 'https://github.com/madanlal1/Hostel-Management-System-Database-Project',
        image: eight
    },
    {
        id: 18,
        projectName: 'PKR Digital Money Exchange',
        projectDesc: 'PKR Digital Money Exchange is developed in CPP Data Structure.',
        tags: ['C++'],
        code: 'https://github.com/madanlal1/PKR-Digital-Money-Exchange-Data-Structure-Project',
        demo: 'https://github.com/madanlal1/PKR-Digital-Money-Exchange-Data-Structure-Project',
        image: ninth
    },
    {
        id: 19,
        projectName: 'ToDo List App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React', 'CSS', 'Bootstrap'],
        code: 'https://github.com/madanlal1/Todo-App-Localstorage-Integration',
        demo: 'https://madanlal1.github.io/Todo-App-Localstorage-Integration/',
        image: four
    },
    {
        id: 20,
        projectName: 'Vehicle Parking Management System',
        projectDesc: 'Vehicle Parking Management is developed in C# language.',
        tags: ['C#'],
        code: 'https://github.com/madanlal1/Vehicle-Parking-Management-System-C_Sharp-Project',
        demo: 'https://github.com/madanlal1/Vehicle-Parking-Management-System-C_Sharp-Project',
        image: tenth
    },
    {
        id: 21,
        projectName: 'Google Keep Clone',
        projectDesc: 'I have crafted a detailed replica of Google Keep with concise yet functional HTML, CSS, and JavaScript code, achieving a balance between complexity and simplicity.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/madanlal1/Google-Keep-Clone',
        demo: 'https://madanlal1.github.io/Google-Keep-Clone/',
        image: three
    },
    {
        id: 22,
        projectName: 'Online Code Editor',
        projectDesc: 'This online code editor, developed in HTML, CSS, and JavaScript, is a dynamic playground for coding enthusiasts, providing an effortless avenue to enhance coding skills.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/madanlal1/Online-Code-Editor',
        demo: 'https://madanlal1.github.io/Online-Code-Editor/',
        image: one
    },
    {
        id: 23,
        projectName: 'QR Code Generator',
        projectDesc: 'Create Your QR Codes Instantly! Free & Easy',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://darosoft.com/tools/qr-code/',
        demo: 'https://darosoft.com/tools/qr-code/',
        image: qr
    },
    {
        id: 24,
        projectName: 'Random Email Generator',
        projectDesc: 'Generate Temporary Emails! Free & Easy',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://darosoft.com/tools/random-email-generator/',
        demo: 'https://darosoft.com/tools/random-email-generator/',
        image: tempmail
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/